<div class="aprova-input">
  @if (label) {
  <div class="aprova-input__label-box">
    <label
      [for]="id"
      [attr.data-testid]="dataTestid ? 'textFieldLabel-' + dataTestid : undefined"
      [class]="labelClass"
    >
      {{ label }}
    </label>

    @if (optionalTag) {
    <span class="aprova-input__optional-tag">(opcional)</span>
    }
  </div>
  }

  <div
    class="aprova-input__input-box"
    [class.aprova-input__input-box--border]="!filled"
    [class.aprova-input__input-box--filled]="filled"
    [class.aprova-input__input-box--disabled]="disabled"
    [class.aprova-input__input-box--error]="hasError"
    [class.aprova-input__input-box--rounded]="!squared"
    [style.width]="width || 'auto'"
    [style.height]="height || '40px'"
    [style.box-shadow]="shadow ? '0px 5px 5px -5px rgba(0, 0, 0, 0.1)' : ''"
  >
    <div #prependRef>
      <ng-content select="[prepend]"></ng-content>
    </div>

    <input
      #input
      [id]="id"
      [name]="inputName"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      [placeholder]="placeholder"
      [style.padding-right]="isAppendSlotUsed ? '36px' : '12px'"
      [class]="inputClass"
      [attr.data-testid]="dataTestid ? 'textField-' + dataTestid : undefined"
      [formControl]="control"
      [required]="required"
      [attr.maxlength]="maxLength"
      [readonly]="readonly || disabled"
      [disabled]="disabled"
      [mask]="mask"
      [aprovaInputSecurity]="secureInput"
      (paste)="blockPaste ? $event.preventDefault() : null"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      (input)="handleInput($event)"
      (change)="handleChange($event)"
    />

    @if (clearButton && control.value && control.value.length) {
    <div class="aprova-input__clear-btn" [class.aprova-input__clear-btn--offset]="isAppendSlotUsed">
      <aprova-icon name="x-outline" size="sm" class="cursor-pointer" (click)="clear()" />
    </div>
    }

    <div #appendRef class="aprova-input__append">
      <ng-content select="[append]"></ng-content>
    </div>
  </div>

  <div class="aprova-input__error-box">
    <div #errorMessageRef>
      <ng-content select="[error-message]"></ng-content>
    </div>

    @if (hasError && !isErrorMessageSlotUsed) {
    <p class="aprova-input__error-message">{{ errorMessageInternal }}</p>
    }
  </div>
</div>
